<template>
  <div class="footer">
    <div class="info">
      <div style="font-size: 25px; padding-bottom:15px; font-weight: bold">SAIL</div>
      <div class="row"><i class="el-icon-office-building"></i>
        <span>
          Southeast University , School of computer science and engineering
        </span></div>
      <div class="row">
        <van-icon name="envelop-o"/>
        tianhe@seu.edu.cn, shuaiwang@seu.edu.cn
      </div>
      <div class="row">Copyright @ SAIL (2025)</div>
      <div class="beian-info">
        <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration:none;" rel="noopener">
          <span>苏ICP备2023050034号-2</span>
        </a>
      </div>
    </div>
    <img src="../assets/logo_seu.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'FooterInfo',
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transform: translateZ(0);

  .wh(100%, 150px);
  .fj(space-between);
  background: #4c733d;
  color: #F8F8F8;

  align-items: center;
  align-content: center;

  .info {
    margin-left: 18%;

  }

  .row {
    margin-bottom: 20px;
    font-size: 12px;

    &:last-child {
      margin-bottom: 0;
      margin-top: 13px;
      font-weight: bold;
    }
  }

  img {
    display: block;
    margin: auto;
  }

  .beian-info {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;


    a span {
      color: #F8F8F8; /* 确保备案号的颜色与整体一致 */
    }
  }
}

</style>
